export function cleanToken(token) {
  return token.replaceAll(/bearer /gi, '');
}
//# sourceMappingURL=cleanToken.js.map